import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'

import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props) {
  let patient_id = useDataValue({
    context: 'patient',
    path: '_id',
    viewPath: props.viewPath,
  })
  let treatment_id = useDataValue({
    context: 'treatment_card',
    path: 'txs._id',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!value.appointment_type_id) return true

    let mutationResponse = await executeMutation({
      patient_id,
      treatment_id,
      appointment_type_id: value.appointment_type_id,
      location_id,
      previous_appointment_id: value.previous_appointment_id,
    })
    if (mutationResponse.error) {
      notify(
        notifyError(
          `There was a problem adding the appointment. Please try again.`
        )
      )
      return
    }
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
